<template>
<div>
    <!-- loader -->
    <Loader />
    <!-- loader -->

    <!-- login-area -->
    <section class="login-area">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="form-area">
                        <div class="login-form">
                            <div class="form-logo">
                                <router-link to="/"><img class="img-fluid" src="@/assets/img/logo.svg" alt="logo"></router-link>
                                <h3>Set new password</h3>
                            </div>
                            <form @submit.prevent="changePassSubmit" class="wow fadeInRight" data-wow-duration="1s" data-wow-delay="1s">
                                <label for="Password">
                                    <p class="label-txt label-active">Password</p>
                                    <img class="img-fluid log-icon" src="@/assets/img/lock.svg" alt="image title">
                                    <input :type="pType" v-model="PasswordParams.password" class="input input-active" required />
                                    <img class="img-fluid show-eye show-peye" src="@/assets/img/eye.svg" alt="" @click="showPass('p')" />
                                    <img class="img-fluid hide-eye hide-peye" src="@/assets/img/eyeclose.svg" alt="" @click="hidePass('p')" style="display: none" />
                                </label>
                                <label for="Confirm">
                                    <p class="label-txt label-active">Confirm password</p>
                                    <img class="img-fluid log-icon" src="@/assets/img/lock.svg" alt="image title">
                                    <input :type="pcType" v-model="PasswordParams.confirm_password" class="input input-active" required />
                                    <img class="img-fluid show-eye show-c-eye" src="@/assets/img/eye.svg" alt="" @click="showPass('c')" />
                                    <img class="img-fluid hide-eye hide-ceye" src="@/assets/img/eyeclose.svg" alt="" @click="hidePass('c')" style="display: none" />
                                </label>

                                <button type="submit" class="login-btns">Confirm </button>
                            </form>
                            <div class="other-login">
                                <router-link to="/login">Cancel</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- login-area -->
</div>
</template>

<script>
import $ from "jquery";
import {
    ref,
    onMounted
} from "vue";
import {
    useRouter
} from 'vue-router';
import Loader from "@/components/Loader";
import axios from "axios";
// console.log(localStorage);
export default {
    components: {
        Loader
    },
    setup() {
        let base_url = "http://api.streamly.com/uploads/";
        const router = useRouter();
        const pType = ref('password');
        const pcType = ref('password');
        let PasswordParams = ref({
            password: '',
            confirm_password: ''
        });
        let forgotEmail = localStorage.getItem("forgot_email") || "";
        let forgotUserId = localStorage.getItem("forgot_user_id") || "";

        const changePassSubmit = async () => {
            let password = PasswordParams.value.password;
            let confirm_password = PasswordParams.value.confirm_password;
            if (password == '') {
                showToast('error', 'Password is required');
                return false;
            } else {
                if (!isPasswordValid(password)) {
                    showToast('error', 'Password must be at least 8 characters, must contain at least 1 uppercase, 1 lowercase and 1 number');
                    return false;
                } else {
                    if (confirm_password === password) {
                        console.log('Passwords match!');
                    } else {
                        showToast('error', 'Passwords do not match');
                        return false;
                    }
                }
            }
            $('.login-btns').attr('disabled', true);
            window.showHideMainLoader(true);
            const postFormData = new FormData();
            postFormData.append('user_id', forgotUserId);
            postFormData.append('email', forgotEmail);
            postFormData.append('password', password);
            await axios
                .post(axios.defaults.baseUrl + "resetPassword",
                    postFormData
                )
                .then((response) => {
                    console.log(response);
                    localStorage.clear();
                    localStorage.setItem("forgot_message", "forgot_message");
                    router.push('/login');
                    window.showHideMainLoader(false);
                    // $('.login-btns').removeAttr('disabled');
                })
                .catch((error) => {
                    window.showHideMainLoader(false);
                    showToast(error.response.data.status, error.response.data.message);
                    $('.login-btns').removeAttr('disabled');
                    return false;
                });
        }
        const showPass = (param) => {
            if (param == 'p') {
                pType.value = "text";
            } else {
                pcType.value = "text";
            }
            $(".hide-" + param + "eye").show();
            $(".show-" + param + "eye").hide();
        };
        const hidePass = (param) => {
            if (param == 'p') {
                pType.value = "password";
            } else {
                pcType.value = "password";
            }
            $(".hide-" + param + "eye").hide();
            $(".show-" + param + "eye").show();
        };
        const showToast = (toastIcon, toastMessage) => {
            window.toast.fire({
                icon: toastIcon,
                title: toastMessage,
            });
        }
        const isPasswordValid = (email) => {
            let regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;
            return regex.test(email);
        }
        onMounted(() => {
            $(".inputs input").first().focus();
            setTimeout(() => {
                window.showHideMainLoader(false);
            }, 500);
        });

        return {
            base_url,
            pType,
            pcType,
            showPass,
            hidePass,
            changePassSubmit,
            forgotEmail,
            forgotUserId,
            PasswordParams,
            showToast,
            isPasswordValid
        };
    },
};
</script>
